import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useGlobalMutation, useGlobalQuery } from '@/state/query-client/hooks';
import { useToast } from '@/hooks/use-toast';
import {
  createConditionalOffer,
  getConditionalOffers,
  getDepartmentsLookup,
  getEmployeesLookup,
} from '../services/offer.service';
import { ConditionalOfferInsertInput, GetConditionalOffersParams } from '../types/offer.types';

export const useGetConditionalOffers = (params: GetConditionalOffersParams) => {
  return useGlobalQuery({
    queryKey: ['hr-conditional-offers', params],
    queryFn: () => getConditionalOffers(params),
    staleTime: 60 * 1000,
  });
};

export const useGetDepartmentsLookup = () => {
  return useGlobalQuery({
    queryKey: ['hr-departments-lookup'],
    queryFn: () => getDepartmentsLookup(),
    staleTime: 30 * 60 * 1000,
  });
};

export const useGetEmployeesLookup = (keyword: string) => {
  return useGlobalQuery({
    queryKey: ['hr-offers-employees-lookup', keyword],
    queryFn: () => getEmployeesLookup(keyword),
    staleTime: 60 * 1000,
  });
};

export const useCreateConditionalOffer = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();

  return useGlobalMutation({
    mutationFn: (input: ConditionalOfferInsertInput) => createConditionalOffer(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['hr-conditional-offers'] });
      toast({ title: t('OFFER_CREATED') });
    },
  });
};
